import { motion } from "framer-motion";

export const easeOutExpo = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: easeOutExpo }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, label, light = false }) => (
  <div className="flex items-center gap-4">
    <span className={`font-serif text-sm italic ${light ? "text-beige-deep" : "text-beige-deep"}`}>
      {index}
    </span>
    <span className={`h-px w-10 ${light ? "bg-cream/25" : "bg-petrol/25"}`} />
    <span
      className={`text-[0.65rem] font-semibold tracking-[0.28em] uppercase ${
        light ? "text-cream/70" : "text-petrol/70"
      }`}
    >
      {label}
    </span>
  </div>
);
